export interface SlackUserLink {
  teamId: string;
  slackUserId: string;
  userId: string;
  createdAt: string;
  slackUserName: string | null;
  slackUserHandle: string | null;
  slackUserAvatarUrl: string | null;
  userName: string | null;
  userEmail: string | null;
}

export interface SlackChannelBinding {
  teamId: string;
  channelId: string;
  boundBy: string;
  updatedAt: string;
  channelName: string | null;
  channelIsPrivate: boolean;
  channelIsIm: boolean;
  channelIsMpim: boolean;
  boundByName: string | null;
  boundByHandle: string | null;
}

export type PendingAction =
  | { variant: 'unlink'; teamId: string; slackUserId: string; name: string }
  | { variant: 'unbind'; teamId: string; channelId: string; name: string };

export const ACTION_CONFIG: Record<
  PendingAction['variant'],
  { title: string; confirmLabel: string; describe: (name: string) => string }
> = {
  unlink: {
    title: 'Disconnect user',
    confirmLabel: 'Disconnect',
    describe: (name) => `${name} will need to run /lookout connect again before they can talk to Lookout in Slack DMs.`,
  },
  unbind: {
    title: 'Disconnect channel',
    confirmLabel: 'Disconnect',
    describe: (name) =>
      `New messages in ${name} will no longer route to this workspace until someone runs /lookout setup again. Existing Slack threads may continue until they end.`,
  },
};

export const SLACK_COMMANDS: { cmd: string; desc: string }[] = [
  { cmd: 'connect', desc: 'Connect or switch your workspace for DMs' },
  { cmd: 'setup', desc: 'Connect this Slack channel to your Lookout workspace' },
  { cmd: 'status', desc: 'Show your current connection info' },
  { cmd: 'help', desc: 'List the available commands' },
];

export const SUBSECTION_HEADING = 'text-xs font-bold tracking-wider text-muted-foreground uppercase';
